
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { PersonSearchCandidateSliderComponent } from '../person-search-candidate-slider/person-search-candidate-slider.component';
import { MatTooltipModule } from '@angular/material/tooltip';
import { CompanyHoverModalComponent } from '../company-hover-modal/company-hover-modal.component';
import { PersonSearchContactSliderComponent } from '../person-search-contact-slider/person-search-contact-slider.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { PersonSearchSimilarSliderComponent } from '../person-search-similar-slider/person-search-similar-slider.component';
import { PersonSearchActivityComponent } from './person-search-activity/person-search-activity.component';
import { AddContactDetailsSliderComponent } from '../add-contact-details-slider/add-contact-details-slider.component';
import { NgxIntlTelInputModule } from 'ngx-intl-tel-input';

@NgModule({
  declarations: [
    PersonSearchCandidateSliderComponent,
    CompanyHoverModalComponent,
    PersonSearchContactSliderComponent,
    PersonSearchSimilarSliderComponent,
    PersonSearchActivityComponent,
    AddContactDetailsSliderComponent
    
  ],
  imports: [
    CommonModule,
    MatTooltipModule,
    FormsModule,
    ReactiveFormsModule,
    NgbModule,
    NgxIntlTelInputModule
    
  ],
  exports: [
    PersonSearchCandidateSliderComponent,
    CompanyHoverModalComponent,
    PersonSearchContactSliderComponent,
    PersonSearchActivityComponent
    
  ]
})
export class PersonSearchModule { }
